'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var Button = require('@narvar/nth-block-button');
var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

// Hack the button component to show a proper outline button
const StyledButton = styled__default["default"](Button__default["default"]).withConfig({
  componentId: "sc-r5i8jw-0"
})(["", ";"], _ref => {
  let {
    s: {
      buttonsSecondaryDefault,
      buttonsSecondaryHover,
      selected
    }
  } = _ref;
  return styled.css(["border-color:", ";border-width:1px;border-style:solid;background:", ";filter:", ";color:", ";@media (hover:none){&:hover{border-color:", ";border-width:1px;border-style:solid;}}@media (hover:hover){&:hover{color:", ";border-color:", ";border-width:1px;border-style:solid;filter:brightness(90%);}}&:active{color:", ";border-color:", ";border-width:1px;border-style:solid;filter:brightness(90%);}"], buttonsSecondaryDefault === null || buttonsSecondaryDefault === void 0 ? void 0 : buttonsSecondaryDefault.color, buttonsSecondaryDefault === null || buttonsSecondaryDefault === void 0 ? void 0 : buttonsSecondaryDefault.backgroundColor, selected ? 'brightness(50%)' : 'brightness(100%)', buttonsSecondaryDefault === null || buttonsSecondaryDefault === void 0 ? void 0 : buttonsSecondaryDefault.color, buttonsSecondaryHover === null || buttonsSecondaryHover === void 0 ? void 0 : buttonsSecondaryHover.color, buttonsSecondaryHover === null || buttonsSecondaryHover === void 0 ? void 0 : buttonsSecondaryHover.color, buttonsSecondaryHover === null || buttonsSecondaryHover === void 0 ? void 0 : buttonsSecondaryHover.color, buttonsSecondaryHover === null || buttonsSecondaryHover === void 0 ? void 0 : buttonsSecondaryHover.color, buttonsSecondaryHover === null || buttonsSecondaryHover === void 0 ? void 0 : buttonsSecondaryHover.color);
});
const SecondaryButton = _ref2 => {
  let {
    children,
    selected,
    ...props
  } = _ref2;
  const {
    buttonsSecondaryDefault,
    buttonsSecondaryHover
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(StyledButton, _extends__default["default"]({
    outline: true
  }, props, {
    s: {
      buttonsSecondaryDefault,
      buttonsSecondaryHover,
      selected: selected ?? false
    }
  }), children);
};
var SecondaryButton$1 = nthHookTheme.withThemeProvider(SecondaryButton, {
  themeTokens: ['buttonsSecondaryDefault', 'buttonsSecondaryHover']
});

exports["default"] = SecondaryButton$1;
